import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { OPERATOR, PaginatiorInfo, WhereConstraints } from '../../../graphql/common.datatypes';
import { WcvLog, WcvLogLevel } from '../../../graphql/logs.datatypes';

interface LogsData {
    logs: {
        data: WcvLog[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const GET_LOGS_QUERY = gql`
    query getLogs($count: Int!, $page: Int!, $where: WhereConditions, $orderBy: [OrderByClause!]){
        logs(first: $count, page: $page, where: $where, orderBy: $orderBy){
            data {
                id
                level
                type
                type_id
                code
                description
                resolved
                payload
                created_at
                user {
                    id
                    first_name
                    last_name
                    email
                }
            }
        }
    }
`;

const getConstraints = () => {
    const whereConstraints: WhereConstraints = {
        AND: [],
    };

    whereConstraints.AND!.push({
        column: 'level',
        operator: OPERATOR.IN,
        value: [WcvLogLevel.FATAL, WcvLogLevel.ERROR, WcvLogLevel.WARN]
    });

    whereConstraints.AND!.push({
        column: 'code',
        operator: OPERATOR.NOT_IN,
        value: ['U101', 'U102', 'U103', 'U104']
    });

    return whereConstraints;
};

export const getPriorityLogs = () => useQuery<LogsData>(
    GET_LOGS_QUERY,
    {
        variables: {
            count: 30,
            page: 1,
            where: getConstraints(),
            orderBy: [{column: 'created_at', order: 'DESC'}],
        }
    }
);

export default getPriorityLogs;
